import {Component, Input} from '@angular/core';
import {Badge} from '../../model/model';

@Component({
    selector: 'badge-image',
    templateUrl: 'badge-image.html',
})
export class BadgeImage {

  @Input() public badge: Badge = null;

  public get badgeImage(): string {
    return 'assets/img/badge/badge' + this.badge.shape + '.png';
  }
}
